// extracted by mini-css-extract-plugin
export default {"results":"Ir0kJOygt7rGXqVpnkGz","resultsList":"HIm1ycXHN39lT8XeksjQ","resultsSectionHeading":"IPBaZseMCQVtmcM0Z4jv"};